import { ContractV7Offer } from '../../api/dashboardV7/contract/contractV7Offer';
import { PushV7 } from '../../api/dashboardV7/pushV7';
import { CommercialPushViewModel } from './commercialPush.view-model';
import { DashboardV7AlertsViewModel } from './dashboard/dashboardV7-alerts.view-model';
import { DashboardV7HelpsViewModel } from './dashboard/dashboardV7-helps.view-model';
import { DashboardV7WarnsViewModel } from './dashboard/DashboardV7WarnsViewModel';
import { ItemHelpViewModel } from './itemHelp.view-model';
import { ItemHomeViewModel } from './itemHome.view-model';
import { ItemV7ViewModel } from './itemV7.view-model';
import { LasBillViewModel } from './lastBill.view-model';
import { OptionsViewModel } from './options.view-model';

export class SectionV7ViewModel {
    public id: string;
    public title: string;
    public message: string;
    public offer: ContractV7Offer;
    public lastBill: LasBillViewModel;
    public itemsSim: ItemV7ViewModel[] = [];
    public itemsHome?: ItemHomeViewModel;
    public itemsEntertainment: ItemV7ViewModel[] = [];
    public itemsCybersecure: ItemV7ViewModel[] = [];
    public itemMultiSim?: ItemV7ViewModel[] = [];
    public itemHelp?: ItemHelpViewModel;
    public changeOffer?: PushV7;
    public changeMobile?: PushV7;
    public commercialPush?: CommercialPushViewModel;
    public options?: OptionsViewModel;
    public alerts?: DashboardV7AlertsViewModel[];
    public infos?: DashboardV7HelpsViewModel[];
    public warnings?: DashboardV7WarnsViewModel[];
    public brand?: string;
    public contractId: string;
}
